import React, { Suspense, lazy } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { SkeletonLoader } from "./components/Skeleton";
import MainLayout from "./layouts/MainLayout";
import LoginScreen from "./components/LoginScreen";
import { useQrContextSync } from "./utils/tableId";
import Orderview from "./components/Orderview";

const MenuPage = lazy(() => import("./components/MenuPage"));
const Cart = lazy(() => import("./components/Cart"));
const Search = lazy(() => import("./components/Search"));
const Account = lazy(() => import("./components/Account"));
const OrderHistory = lazy(() => import("./components/OrderHistory"));

function App() {
  const { ready, invalid } = useQrContextSync();
  const location = useLocation();

  if (invalid) return <div role="alert">Invalid QR code. Please scan a table or branch QR code.</div>;
  if (!ready) return <SkeletonLoader />;

  return (
    <Suspense fallback={<div className="min-h-screen bg-[#edf7f2] flex items-center justify-center"><SkeletonLoader /></div>}>
      <Routes location={location}>
        {/* Standalone login page — no nav / footer / splash */}
        <Route path="/login" element={<LoginScreen />} />

        {/* Main app with nav, footer, splash */}
        <Route element={<MainLayout />}>
          <Route path="/" element={<MenuPage />} />
          <Route path="/:qrId" element={<MenuPage />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/search" element={<Search />} />
          <Route path="/account" element={<Account />} />
          <Route path="/account/order-history" element={<OrderHistory />} />
          <Route path="/order-view" element={<Orderview />} />
        </Route>
      </Routes>
    </Suspense>
  );
}

export default App;